import './DeleteModal.scss';
import React, {useEffect, useState} from 'react';
import { Spinner } from '@trp-beacon-ui-kit/react-communication';
import classNames from 'classnames';
import {
  AAMBeaconButton,
  AAMBeaconIconButton,
  AAMBeaconModal
} from 'components/shared/Beacon';
import { getCustomerWebView } from 'state/customer/CustomerSelectors';
import {connect} from "react-redux";
import WithUserPermissions from '../WithUserPermissions/WithUserPermissions';
import {dispatchOverlayLoad} from "state/logic/AnalyticsLogic";

const DeleteCTAWithPermissions = WithUserPermissions(AAMBeaconButton);
const DeleteModal = ({
  id = 'delete-modal',
  title,
  modalContent,
  linkContent,
  icon,
  defaultIconSizing,
  closeOnClickOut,
  ctaButtons,
  CTA,
  children,
  className = '',
  size = 'normal',
  leftButtonVariant = 'tertiary',
  leftButtonLabel = 'Cancel',
  leftButtonScale = 'jumbo',
  rightButtonVariant = 'tertiary',
  rightButtonLabel = 'Cancel',
  rightButtonScale = 'jumbo',
  receivedDeleteSuccess = false,
  receivedDeleteError = false,
  setFailedCounter,
  failedCounter,
  isCustomerWebView
}) => {
  const [showModal, setShowModal] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);

  const handleClose = () => {
    let modal = document.getElementById(id);
    if (modal && modal.close) {
      modal.close();
    }
    setFailedCounter(0);
    setShowModal(false);
  };

  const handleCloseBeacon = () => {
    setFailedCounter(0);
    setShowModal(false);
  };

  const handleClick = () => {
    setShowModal(true);
    dispatchOverlayLoad("Are you sure?");
  };
  const handleCTA = () => {
    CTA();
    setShowSpinner(true);
    if (receivedDeleteSuccess) {
      handleClose();
      setShowSpinner(false);
    }
    if (receivedDeleteError) {
      setFailedCounter(failedCounter + 1);
      dispatchOverlayLoad("Something went wrong");
      setShowSpinner(false);
    }
  };

  useEffect(() => {
    if (receivedDeleteSuccess && showSpinner && !receivedDeleteError) {
      setTimeout(() => {
        setShowSpinner(false);
      }, 500);
      handleClose();
    }
    if (receivedDeleteError && failedCounter === 0) {
      setFailedCounter(failedCounter + 1);
      dispatchOverlayLoad("Something went wrong");
      setTimeout(() => {
        setShowSpinner(false);
      }, 500);
    }
  }, [receivedDeleteSuccess, showSpinner, receivedDeleteError]);

  return (
    <div className="beacon-delete-modal-container">
      {showModal && (
        <AAMBeaconModal
          className={className}
          size={size}
          id={id}
          dataMetricsLocation="PU"
          open={true}
          description={modalContent}
          onBeaconEventClose={() => handleCloseBeacon()}
          closeOnClickOut={closeOnClickOut}>
          {title && <div className="b-typography-serif--headline--200">{title}</div>}
          {children}
          {ctaButtons && (
            <span slot="action-zone" className="action-zone-align-right">
              <AAMBeaconButton
                onBeaconEventClick={() => handleClose()}
                variant={leftButtonVariant}
                id="left-button-modal"
                scale={leftButtonScale}
              >
                {leftButtonLabel}
              </AAMBeaconButton>
              {!showSpinner && (
                <DeleteCTAWithPermissions
                  shouldDisable
                  onBeaconClick={() => handleCTA()}
                  variant={rightButtonVariant}
                  scale={rightButtonScale}
                  disabled={failedCounter >= 3 || isCustomerWebView}
                  id="right-button-modal"
                  label={rightButtonLabel}
                />
              )}
              {showSpinner && (
                <span className="statements-spinner">
                  <Spinner />
                </span>
              )}
            </span>
          )}
        </AAMBeaconModal>
      )}
      {icon && !linkContent && (
        <AAMBeaconIconButton
          className={classNames({
            'default-icon-sizing': defaultIconSizing,
            'beacon-delete-modal-icon-trigger': !defaultIconSizing
          })}
          id="beacon-delete-modal-icon-trigger"
          onBeaconEventClick={handleClick}
          variant={'tertiary'}
          >
          Delete Application
          {icon}
        </AAMBeaconIconButton>
      )}
      {linkContent && (
        <button
          className="beacon-delete-modal-link-trigger"
          data-testid="beacon-delete-modal-link-trigger"
          onClick={handleClick}>
          {linkContent}
        </button>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  isCustomerWebView: getCustomerWebView(state)
});

export default connect(mapStateToProps)(DeleteModal);
